import Vue from "vue";
import Vuex from "vuex";
import processes from "./modules/processes";
import competences from "./modules/competences";
import stepByStepGuide from "./modules/step-by-step-guide";
import ProofOfMembership from "./modules/proof-of-membership";

Vue.use(Vuex);

Vue.config.devtools = true; // TEMP

export default new Vuex.Store ({
  modules: {
    processes, competences, stepByStepGuide, ProofOfMembership
  },
});
